module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_uganda-57af09a8.png";